// eslint-disable-next-line @typescript-eslint/no-explicit-any
const loggingEnabled = () => (window as any).DEBUG || (window as any).DEBUG_FORMS || false;

export class FormUpdatesController {
  submit: HTMLButtonElement;
  hasChanged: boolean;

  constructor(form: HTMLFormElement) {
    this.hasChanged = false;

    this.submit = form.querySelector("button[data-form-updates]") as HTMLButtonElement;

    if (this.submit) {
      this.submit.disabled = true;
    }

    this.initEventListeners(form);
  }

  initEventListeners(form: HTMLFormElement) {
    window.addEventListener("submit", () => this.handleSubmit());
    form.addEventListener("submit", () => this.handleSubmit());
    window.addEventListener("beforeunload", (e) => this.handleBeforeUnload(e));

    for (const element of Array.from(form.elements)) {
      const field = element as HTMLInputElement | HTMLSelectElement;

      if (field.type == "submit" || field.type == "button" || field.type == "hidden") {
        // if data values do not include data-track-updates, ignore this field
        if (field.dataset.trackUpdates == undefined) {
          continue;
        }
      }

      if (!field.name) {
        console.warn("[FormUpdatesController.ts] field has no name", field);
        continue;
      }

      field.addEventListener("input", () => {
        if (this.hasChanged) {
          // Once we've changed once, there's nothing more to do
          return;
        }

        this.hasChanged = true;

        if (this.submit) {
          this.submit.disabled = false;
        }

        if (loggingEnabled()) {
          console.log("[FormUpdatesController.ts] listening to changes on field", field.name);
        }
      });
    }
  }

  handleSubmit() {
    this.hasChanged = false;

    if (this.submit) {
      this.submit.disabled = true;
    }
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
  handleBeforeUnload(e: BeforeUnloadEvent) {
    if (this.hasChanged) {
      // Cancel the event
      e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown

      // Chrome requires returnValue to be set
      e.returnValue = "";
    }
  }
}
